let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsOverlappedResult = require('../operations/types/isOverlappedResult');


/**
 * Класс IsOverlapped
 * @extends AbstractOperation
 */
class IsOverlapped extends AbstractOperation {

    /**
     * Создает экземпляр класса IsOverlapped
     */
  constructor() {
    super()
  }


    /**
     *
     * @param featureA
     * @param featureB
     * @return {boolean}
     */
    execute(featureA, featureB) {
        let isOverlapped = operation(featureA, featureB);
        return new IsOverlappedResult({
            result: isOverlapped
        })
    }
    }

function operation(featureA, featureB) {
    let geomA = parser.read(featureA.getGeometry());
    let geomB = parser.read(featureB.getGeometry());
    let result = geomA.overlaps(geomB);
    return result
}



module.exports = IsOverlapped;